module.exports = __webpack_public_path__ + "static/media/diaryImg1.4a420dde.jpg";